import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import messages from 'containers/CourtManagerLegalProceedings/Provision/messages';
import { translate } from 'containers/services/translate';
import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import DrawerIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/drawer-icon';
import AddIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/add-icon';
import ProvisionDialog from 'containers/CourtManagerLegalProceedings/Provision/provisionDialog';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';

export interface GlobalProvisionProps {
  intl: IntlShape;
  provisions: any;
  requestValidateProvisionIntervenant?: Function;
  riskId: string;
  claimNumber?: string;
  riskName: string;
  setCurrentRisk: Function;
  setUpdateCurrentRisk: Function;
  claimId: number;
  isConsultation: Boolean;
}

export const GlobalProvision: React.FC<GlobalProvisionProps> = ({
  provisions,
  ...props
}): JSX.Element => {
  const [isProvisionDialogOpen, setIsProvisionDialogOpen] = useState<boolean>(
    false,
  );
  const handleCloseProvisionDialog = () => setIsProvisionDialogOpen(false);
  return (
    <>
      <div className="globalProvisionBloc">
        <DrawerIcon />
        <span>{translate(messages.globalProvisionTitle, props)}</span>
        {!props.isConsultation && (
          <div
            data-testid="add-provision"
            className="evalManuel"
            onClick={() => setIsProvisionDialogOpen(true)}
          >
            {props.riskName === RISK_NAME.CORPOREAL && (
              <>
                <AddIcon />
                <span style={{ marginLeft: '10px' }}>
                  {translate(messages.evalTitle, props)}
                </span>
              </>
            )}
          </div>
        )}
      </div>

      <div>
        <Table>
          <TableHead>
            <TableRow className="row">
              <TableCell align="left" className="headerTitle">
                {translate(messages.evalType, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.evalAmount, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.evalDate, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.updatedBy, props)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {provisions.map((el: any) => {
              return (
                <TableRow className="row">
                  <TableCell align="left" className="riskInfo">
                    {el.provisionType}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.provisionAmount}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {props.intl.formatDate(el.provisionDate, {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric',
                    })}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.provisionAuthor}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <ProvisionDialog
        open={isProvisionDialogOpen}
        confirmTitle={translate(messages.provisionValidate, props)}
        cancelTitle={translate(messages.provisionCancel, props)}
        handleClose={handleCloseProvisionDialog}
        title={translate(messages.provisionDialogTitle, props)}
        requestValidateProvisionIntervenant={
          props.requestValidateProvisionIntervenant
        }
        riskId={props.riskId}
        claimNumber={props.claimNumber}
        setCurrentRisk={props.setCurrentRisk}
        setUpdateCurrentRisk={props.setUpdateCurrentRisk}
        claimId={props.claimId}
      />
    </>
  );
};

export default injectIntl(GlobalProvision);
